import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { Box } from "@mui/material";
import React from "react";

export interface ComplianceAreaWrapperProps {
    complianceArea: string | undefined;
    noMargin?: boolean;
}

function ComplianceAreaWrapper(props: ComplianceAreaWrapperProps) {
    return (
        <Box
            sx={(theme) => ({
                border: 1,
                padding: 0.5,
                color: theme.palette.primary.main,
                borderRadius: "8px",
                marginTop: props.noMargin ? "none" : 0.5,
                marginBottom: props.noMargin ? "none" : 0.5,
                backgroundColor: theme.customPalette.white,
                whiteSpace: "nowrap",
            })}
        >
            <DotLegalHeader color="secondary" fontWeight={500} headerStyle={"extraSmall"} marginBottom={0}>
                {props.complianceArea}
            </DotLegalHeader>
        </Box>
    );
}

export default ComplianceAreaWrapper;
